import React from 'react'
import {Loading} from '@therms/atalaya'
import {
  EventListCard,
  NoResults,
  RPCDocs,
  useEvents,
  useLocationContext,
  useRPCServerEventHandler,
} from '@therms/react-modules'
import {useAutoAnimate} from '@formkit/auto-animate/react'

interface ActiveEventsListProps {
  activityTypeIds?: string[]
  dateTimeRange: {start?: string; end?: string}
  eventTypeIds?: string[]
  locationId?: string
  onClickEvent?: (event: RPCDocs.Events.GetEventsList.v1.Event) => void
  searchText?: string
  userIdsAssigned?: string[]
}

function ActiveEventsList({
  activityTypeIds,
  dateTimeRange,
  eventTypeIds,
  locationId,
  onClickEvent,
  searchText,
  userIdsAssigned,
}: ActiveEventsListProps) {
  const locationCtx = useLocationContext()

  const {data, loading, refresh} = useEvents({
    activityTypeIdFilter: activityTypeIds?.length ? activityTypeIds : undefined,
    assignedUserIdFilter: userIdsAssigned,
    eventTypeIds: eventTypeIds?.length ? eventTypeIds : undefined,
    fromDate: dateTimeRange?.start,
    locationId: locationCtx?.locationId ?? locationId,
    searchText,
    stateFilter: [RPCDocs.Events.GetEventsList.v1.StateFilter.Active],
    toDate: dateTimeRange?.end,
  })
  const [autoAnimateParentRef] = useAutoAnimate({})
  useRPCServerEventHandler('EventDeleted', refresh)
  useRPCServerEventHandler('EventCreated', refresh)
  useRPCServerEventHandler('EventDetailsUpdated', refresh)
  useRPCServerEventHandler('EventStateUpdated', refresh)

  return (
    <div className="gap-y-sm flex flex-col">
      {loading && !data?.events?.length && (
        <div className="flex justify-center">
          <Loading size="base" />
        </div>
      )}

      {data?.events?.length ? (
        <div className="gap-xs flex flex-col" ref={autoAnimateParentRef}>
          {data?.events?.map((event) => (
            <EventListCard
              event={event}
              key={event.id}
              onClick={onClickEvent}
            />
          ))}
        </div>
      ) : (
        <NoResults text="No Active Events" />
      )}
    </div>
  )
}

export {ActiveEventsList}
